
import { getQuestions } from './questionService';
import { getSessions } from './practiceService';
import { getDueQuestions } from './reviewService';

export const getStats = async () => {
    const questions = await getQuestions();
    const sessions = await getSessions();
    const todayStart = new Date(); todayStart.setHours(0,0,0,0);
    const yesterdayStart = new Date(todayStart); yesterdayStart.setDate(yesterdayStart.getDate() - 1);
    const weekStart = new Date(todayStart); weekStart.setDate(weekStart.getDate() - 7);

    const total = questions.filter(q => !q.deletedAt).length;
    const masteredCount = questions.filter(q => !q.deletedAt && q.isMastered).length;
    const dueCount = getDueQuestions(questions).length;
    
    const todayMistakes = questions.filter(q => !q.deletedAt && q.createdAt >= todayStart.getTime()).length;
    const yesterdayMistakes = questions.filter(q => !q.deletedAt && q.createdAt >= yesterdayStart.getTime() && q.createdAt < todayStart.getTime()).length;
    const weekMistakes = questions.filter(q => !q.deletedAt && q.createdAt >= weekStart.getTime()).length;
    
    let todayPracticeCount = 0;
    sessions.forEach(s => {
        if (s.date >= todayStart.getTime()) {
            todayPracticeCount += s.details.length;
        }
    });

    return { total, masteredCount, dueCount, todayMistakes, yesterdayMistakes, weekMistakes, todayPracticeCount };
};

export const getTagStats = async (timeFilter: 'today'|'3days'|'week', categoryFilter: string) => {
    const questions = await getQuestions();
    const now = Date.now();
    let startTime = 0;
    if (timeFilter === 'today') { const d = new Date(); d.setHours(0,0,0,0); startTime = d.getTime(); }
    else if (timeFilter === '3days') startTime = now - 3 * 86400000;
    else if (timeFilter === 'week') startTime = now - 7 * 86400000;

    const tagCounts: Record<string, number> = {};
    
    questions.forEach(q => {
        if (q.deletedAt) return;
        if (categoryFilter !== 'All' && q.category !== categoryFilter) return;
        if (q.createdAt < startTime) return;

        q.tags?.forEach(t => {
            tagCounts[t] = (tagCounts[t] || 0) + 1;
        });
    });

    return Object.entries(tagCounts)
        .map(([name, count]) => ({ name, count }))
        .sort((a, b) => b.count - a.count)
        .slice(0, 5);
};
